angular.module("templates/core/layout/navMenu.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("templates/core/layout/navMenu.html",
        "<div>\n" +
        "    <div class=\"app-info\">\n" +
        "    {{ 'config.appName' | translate }}\n" +
        "    </div>\n" +
        "    <nav>\n" +
        "        <ul smart-menu>\n" +
        "            <li data-ui-sref-active=\"active\" ng-repeat-start=\"menuInfo in navMenuVm.menuInfos\" ng-if=\"!menuInfo.subMenuInfos\">\n" +
        "                <a data-ui-sref=\"{{ menuInfo.stateName }}\" title=\"{{ menuInfo.resourceKey | translate }}\">\n" +
        "                    <i class=\"fa fa-lg fa-fw {{menuInfo.iconClass}}\"></i> <span class=\"menu-item-parent\">{{ menuInfo.resourceKey | translate }}</span>\n" +
        "                </a>\n" +
        "            </li>\n" +
        "            <li data-menu-collapse ng-if=\"menuInfo.subMenuInfos != null\" ng-repeat-end>\n" +
        "                <a href=\"#\"><i class=\"fa fa-lg fa-fw {{menuInfo.iconClass}}\"></i> <span class=\"menu-item-parent\">{{ menuInfo.resourceKey | translate }}</span></a>\n" +
        "                <ul>\n" +
        "                    <li data-ui-sref-active=\"active\" ng-repeat=\"subMenuInfo in menuInfo.subMenuInfos\">\n" +
        "                        <a data-ui-sref=\"{{ subMenuInfo.stateName }}\">\n" +
        "                            {{ subMenuInfo.resourceKey | translate }}\n" +
        "                        </a>\n" +
        "                    </li>\n" +
        "                </ul>\n" +
        "            </li>\n" +
        "        </ul>\n" +
        "        <api-navigator></api-navigator>\n" +
        "    </nav>\n" +
        "    <span class=\"minifyme\" minify-menu> <i class=\"fa fa-arrow-circle-left hit\"></i> </span>\n" +
        "</div>\n" +
        "");
}]);